import { NgModule } from '@angular/core';

import { SearchService } from './search.service';

@NgModule({
  imports: [],
  providers: [SearchService],
})
export class SearchModule {}
